import { useState } from "react";
import { Navbar } from "./components/Navbar";
import TextForm from "./components/TextForm";
import Alert from "./components/Alert";
// import About from "./components/About";
// import { BrowserRouter, Routes, Route } from "react-router-dom";

function App() {
  const [mode, setMode] = useState("info");
  const [alert, setAlert] = useState(null);

  const showAlert = (message, type) => {
    setAlert({
      msg: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 1500);
  };

  const toggleModeBlue = () => {
    setMode("info");
    document.body.style.backgroundColor = "white";
    showAlert("White theme enabled", "success");
  };
  const toggleModeGreen = () => {
    setMode("dark");
    document.body.style.backgroundColor = "#198754";
    showAlert("Green theme enabled", "success");
  };
  const toggleModePurple = () => {
    setMode("dark");
    document.body.style.backgroundColor = "#6b055f";
    showAlert("Purple theme enabled", "success");
  };
  return (
    <>
      {/* <BrowserRouter> */}
      <Navbar
        title="Texti"
        mode={mode}
        toggleModeBlue={toggleModeBlue}
        toggleModeGreen={toggleModeGreen}
        toggleModePurple={toggleModePurple}
        aboutText="About TextUtils"
      />
      <Alert alert={alert} />
      <div className="container">
        {/* <Routes>
            <Route exact path="/about" element={<About />} />

            <Route
              exact
              path="/"
              element={ */}
        <TextForm
          heading="UpperCase Convertor"
          mode={mode}
          showAlert={showAlert}
        />
        {/* }
            />
          </Routes> */}
      </div>
      {/* </BrowserRouter> */}
    </>
  );
}

export default App;
